module.exports = __webpack_public_path__ + "img/70-32c5be.png";